export default __webpack_public_path__ + "static/media/about-us-discussion.480892f8.png";